import React, { FC, memo } from "react";
import { Image } from "@sitecore-jss/sitecore-jss-react";
import { ImageField } from "@sitecore-jss/sitecore-jss-react/types/components/Image";
import "./HeaderLogo.scss";

interface HeaderLogoProps {
  isDark: boolean;
  logoBlack: ImageField;
  logoWhite: ImageField;
  href: string;
}

const HeaderLogo: FC<HeaderLogoProps> = memo(
  ({ logoBlack, logoWhite, isDark, href }) => {
    return (
      <>
        <a
          href={href}
          className="Header__logo"
          style={
            isDark
              ? { visibility: "hidden", position: "absolute" }
              : { visibility: "visible", position: "relative" }
          }
        >
          <Image field={logoBlack} />
        </a>
        <a
          href={href}
          className="Header__logo"
          style={
            isDark
              ? { visibility: "visible", position: "relative" }
              : { visibility: "hidden", position: "absolute" }
          }
        >
          <Image field={logoWhite} />
        </a>
      </>
    );
  }
);

export default memo(HeaderLogo);
